import React from "react";
import { Reveal } from "@/components/effects/Reveal";
import { Image, Download, ShoppingBag, Sparkles } from "lucide-react";

export const PhotoSales = () => {
  return (
    <section data-testid="photo-sales-section" className="relative py-28 sm:py-36 bg-[#050507]">
      <div className="max-w-[1280px] mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-[11px] tracking-luxe uppercase text-white/45 mb-4">
                — Event Photo Sales · Coming Soon
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
                <span className="text-chrome">Your moments,</span>
                <br />
                <span className="italic text-magcyan">on demand.</span>
              </h2>
            </Reveal>
            <Reveal delay={240}>
              <p className="mt-7 text-white/65 leading-relaxed font-body">
                After selected events, photos will be uploaded into organised event
                galleries where customers can browse previews, select their favourite
                moments and download their purchased high-quality images.
              </p>
            </Reveal>
            <Reveal delay={360}>
              <div className="mt-8 inline-flex items-center gap-3 px-4 py-2 rounded-full glass chrome-border">
                <Sparkles className="w-3.5 h-3.5 text-[#ff2e93]" />
                <span className="text-[11px] tracking-luxe uppercase text-white/70">Launching in Phase 2</span>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[
                { icon: Image, title: "Browse Galleries", desc: "Beautifully sorted by event, with watermarked previews." },
                { icon: ShoppingBag, title: "Select Favourites", desc: "Add the images you love into a private cart." },
                { icon: Download, title: "Download Originals", desc: "Receive high-resolution, print-ready files instantly." },
              ].map((c, i) => (
                <Reveal key={c.title} delay={i * 120}>
                  <div className="glass chrome-border rounded-md p-6 h-full lift">
                    <div className="w-11 h-11 rounded-full flex items-center justify-center mb-5 chrome-border bg-black/40">
                      <c.icon className="w-4 h-4 text-white" />
                    </div>
                    <h3 className="font-display text-2xl text-chrome mb-2">{c.title}</h3>
                    <p className="text-sm text-white/55 font-body leading-relaxed">{c.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={420}>
              <div className="mt-6 glass chrome-border rounded-md p-6 sm:p-8 relative overflow-hidden">
                <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full"
                  style={{ background: "radial-gradient(circle, rgba(24,211,255,0.18), transparent 70%)" }} />
                <p className="text-[10px] tracking-luxe uppercase text-white/40 mb-3">Sample gallery preview</p>
                <div className="grid grid-cols-4 gap-2">
                  {[
                    "https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=400&q=80&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1519750783826-e2420f4d687f?w=400&q=80&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1530023367847-a683933f4172?w=400&q=80&auto=format&fit=crop",
                    "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=400&q=80&auto=format&fit=crop",
                  ].map((src, i) => (
                    <div key={i} className="photo-frame aspect-square">
                      <img src={src} alt="" className="w-full h-full object-cover" loading="lazy" />
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhotoSales;
